import { render, staticRenderFns } from "./StatTasks.vue?vue&type=template&id=a07f7c64&"
import script from "./StatTasks.vue?vue&type=script&lang=ts&"
export * from "./StatTasks.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports